// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// const WorkerDashboard = () => {
//   const { id } = useParams();
//   const [productStats, setProductStats] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchBills = async () => {
//       try {
//         const res = await axios.get(`http://localhost:5000/bill/${id}`);
//         const productCount = {};
//         res.data.forEach((bill) => {
//           bill.items.forEach((item) => {
//             productCount[item.product] =
//               (productCount[item.product] || 0) + item.quantity;
//           });
//         });
//         setProductStats(productCount);
//       } catch (err) {
//         console.error("Failed to fetch product stats", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBills();
//   }, [id]);

//   if (loading)
//     return (
//       <p className="text-muted text-center mt-4">Loading product stats...</p>
//     );

//   if (Object.keys(productStats).length === 0) {
//     return (
//       <p className="text-muted text-center mt-4">No product stats available.</p>
//     );
//   }

//   return (
//     <div className="p-6">
//       <h2 className="text-success mb-4 text-2xl font-semibold">
//         📦 Product Usage Summary
//       </h2>
//       <div className="row">
//         {Object.entries(productStats).map(([product, count]) => (
//           <div key={product} className="col-md-4 mb-4">
//             <div className="card shadow-sm h-100">
//               <div className="card-body">
//                 <h5 className="card-title text-primary">{product}</h5>
//                 <p className="card-text">
//                   <strong>Stock:</strong> {count}
//                 </p>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default WorkerDashboard;

// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// const WorkerDashboard = () => {
//   const { id } = useParams();
//   const [productStats, setProductStats] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [cart, setCart] = useState({});

//   useEffect(() => {
//     const fetchBills = async () => {
//       try {
//         // const res = await axios.get(`http://localhost:5000/bill/${id}`);
// const res = await axios.get(
//   `http://localhost/murugan/bills/get_by_worker.php?worker_id=${id}`
// );
//         const productCount = {};
//         res.data.forEach((bill) => {
//           bill.items.forEach((item) => {
//             productCount[item.product] =
//               (productCount[item.product] || 0) + item.quantity;
//           });
//         });
//         setProductStats(productCount);
//       } catch (err) {
//         console.error("Failed to fetch product stats", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBills();
//   }, [id]);

//   const handleQuantityChange = (product, value) => {
//     setCart((prev) => ({
//       ...prev,
//       [product]: { ...prev[product], quantity: Number(value) },
//     }));
//   };

//   const addToCart = (product) => {
//     setCart((prev) => ({
//       ...prev,
//       [product]: { quantity: 1 },
//     }));
//   };

//   // const handleCheckout = async () => {
//   //   const items = Object.entries(cart).map(([product, data]) => ({
//   //     product,
//   //     requested: data.quantity,
//   //   }));

//   //   try {
//   //     await axios.post("http://localhost:5000/cart-request", {
//   //       workerId: id,
//   //       items,
//   //       status: "pending",
//   //       createdAt: new Date().toISOString(),
//   //     });
//   //     alert("Request sent to admin!");
//   //     setCart({});
//   //   } catch (err) {
//   //     console.error("Checkout failed", err);
//   //   }
//   // };

// const handleCheckout = async () => {
//   const items = Object.entries(cart).map(([product, data]) => ({
//     product,
//     requested: data.quantity,
//   }));

//   try {
//     await axios.post("http://localhost/murugan/cart-request/create.php", {
//       workerId: id,
//       items,
//     });

//     alert("Request sent to admin!");
//     setCart({});
//   } catch (err) {
//     console.error("Checkout failed", err);
//     alert("Failed to send request. Try again.");
//   }
// };

//   if (loading) return <p className="text-center">Loading...</p>;

//   return (
//     <div className="p-6">
//       <h2 className="text-success text-2xl mb-4">📦 Product Usage Summary</h2>
//       <div className="row">
//         {Object.entries(productStats).map(([product, count]) => (
//           <div key={product} className="col-md-4 mb-4">
//             <div className="card h-100 shadow">
//               <div className="card-body">
//                 <h5 className="card-title text-primary">{product}</h5>
//                 <p>Stock: {count}</p>

//                 <input
//                   type="number"
//                   min={1}
//                   max={count}
//                   className="form-control mb-2"
//                   placeholder="Enter quantity"
//                   value={cart[product]?.quantity || ""}
//                   onChange={(e) =>
//                     handleQuantityChange(product, e.target.value)
//                   }
//                 />
//                 <button
//                   className="btn btn-sm btn-outline-primary"
//                   onClick={() => addToCart(product)}
//                 >
//                   Add to Cart
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {Object.keys(cart).length > 0 && (
//         <div className="text-end mt-4">
//           <button className="btn btn-success" onClick={handleCheckout}>
//             Checkout (Request Approval)
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default WorkerDashboard;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Api } from "../Api/Api";

const WorkerDashboard = () => {
  const { id } = useParams();
  const [productStats, setProductStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState({});

  useEffect(() => {
    const fetchBills = async () => {
      try {
        const res = await axios.get(
          `${Api}bills2/get_by_worker.php?worker_id=${id}`
        );
        const productCount = {};
        res.data.forEach((bill) => {
          bill.items.forEach((item) => {
            productCount[item.product] =
              (productCount[item.product] || 0) + item.quantity;
          });
        });
        setProductStats(productCount);
      } catch (err) {
        console.error("Failed to fetch product stats", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBills();
  }, [id]);

  const addToCart = (product, stock) => {
    setCart((prev) => {
      const currentQty = prev[product]?.quantity || 0;
      if (currentQty < stock) {
        return {
          ...prev,
          [product]: { quantity: currentQty + 1 },
        };
      }
      return prev;
    });
  };

  const removeFromCart = (product) => {
    setCart((prev) => {
      const currentQty = prev[product]?.quantity || 0;
      if (currentQty > 1) {
        return {
          ...prev,
          [product]: { quantity: currentQty - 1 },
        };
      } else {
        const updated = { ...prev };
        delete updated[product];
        return updated;
      }
    });
  };

  const handleCheckout = async () => {
    const items = Object.entries(cart).map(([product, data]) => ({
      product,
      requested: data.quantity,
    }));

    try {
      await axios.post(`${Api}cart-request/create.php`, {
        workerId: id,
        items,
      });

      alert("Request sent to admin!");
      setCart({});
    } catch (err) {
      console.error("Checkout failed", err);
      alert("Failed to send request. Try again.");
    }
  };

  if (loading) return <p className="text-center">Loading...</p>;

  return (
    <div className="p-6">
      <h2 className="text-success text-2xl mb-4">📦 Product Usage Summary</h2>
      <div className="row">
        {Object.entries(productStats).map(([product, stock]) => {
          const cartQty = cart[product]?.quantity || 0;
          return (
            <div key={product} className="col-md-4 mb-4">
              <div className="card h-100 shadow">
                <div className="card-body">
                  <h5 className="card-title text-primary">{product}</h5>
                  <p>Available Stock: {stock}</p>

                  {cartQty === 0 ? (
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => addToCart(product, stock)}
                    >
                      Add to Cart
                    </button>
                  ) : (
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => removeFromCart(product)}
                      >
                        -
                      </button>
                      <span>{cartQty}</span>
                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() => addToCart(product, stock)}
                        disabled={cartQty >= stock}
                      >
                        +
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {Object.keys(cart).length > 0 && (
        <div className="text-end mt-4">
          <button className="btn btn-success" onClick={handleCheckout}>
            Checkout (Request Approval)
          </button>
        </div>
      )}
    </div>
  );
};

export default WorkerDashboard;
